import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustBadges from "./components/TrustBadges";
import CategoriesGrid from "./components/CategoriesGrid";
import ComparisonSection from "./components/ComparisonSection";
import HowItWorks from "./components/HowItWorks";
import ArticlesSection from "./components/ArticlesSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://vigorbuy.quest";

export default function Home() {
  return (
    <>
      {/* WebPage Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Best VigorBuy Spreadsheet 2026 – Trusted Sellers, QC & Shipping Guides",
            description:
              "Discover the most complete VigorBuy Spreadsheet with verified sellers, quality checks, shipping tutorials and weekly updates. Start shopping smarter with 5000+ products across 14 categories.",
            url: `${siteUrl}/`,
            about: {
              "@type": "Thing",
              name: "VigorBuy Spreadsheet",
            },
            dateModified: "2026-06-29",
          }),
        }}
      />
      {/* Organization Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "VigorBuy Spreadsheet",
            url: `${siteUrl}/`,
            description:
              "The most complete VigorBuy Spreadsheet resource with verified sellers, QC guides, and shipping tutorials. Updated weekly with 5000+ products across 14 categories.",
            sameAs: ["https://kaspreadsheet.com"],
          }),
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <TrustBadges />
        <CategoriesGrid />
        <ComparisonSection />
        <HowItWorks />
        <ArticlesSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}